class DreambabyReturnToHandler {
  constructor() {
    this.defaultReturnPath = '/account';
    this.init();
  }

  init() {
    this.setReturnToValues();
  }

  /**
   * @returns {string} The return_to value or default fallback
   */
  getReturnToValue() {
    const urlParams = new URLSearchParams(window.location.search);
    const returnToParam = urlParams.get('return_to');

    if (!returnToParam) {
      return this.defaultReturnPath;
    }

    return this.validateReturnToPath(returnToParam);
  }

  /**
   * @param {string} path - The path to validate
   * @returns {string} Valid path or default fallback
   */
  validateReturnToPath(path) {
    if (!path || typeof path !== 'string') {
      return this.defaultReturnPath;
    }

    const cleanPath = path.trim();
    if (cleanPath.startsWith('/') || cleanPath.startsWith('account')) {
      return cleanPath;
    }

    return this.defaultReturnPath;
  }

  setReturnToValues() {
    const returnToValue = this.getReturnToValue();
    const returnToInputs = document.querySelectorAll('input[name="return_to"]');

    returnToInputs.forEach((input) => {
      input.value = returnToValue;
    });
  }
}

if ('loading' === document.readyState) {
  document.addEventListener('DOMContentLoaded', () => new DreambabyReturnToHandler());
} else {
  new DreambabyReturnToHandler();
}
